import React from "react";

const TitleHeader = ({ title, description }) => {
  return (
    <div
      className="flex items-center justify-center text-center text-white md:min-h-[45vh] min-h-[40vh] bg-cover bg-center relative"
      style={{
        backgroundImage: `url(/assets/12.webp)`,
      }}
    >
      {/* <div className="w-full h-full absolute top-0 left-0 z-0" /> */}
      <div className="flex flex-col relative top-8 gap-4 z-10 px-4">
        <h1 className="text-4xl md:text-[3rem] text-primary-200 font-bold">
          {title}
        </h1>
        <p className="text-lg text-primary-gradient">
          {description}
        </p>
      </div>
    </div>
  );
};

export default TitleHeader;
